module.exports = __webpack_public_path__ + "static/04-1d6cb69e171a8b9bf1506e6105624cd4.png";